<template>
  <div class="video_instructions__item">
    <div class="video_instructions__number">{{posNumber}}.</div>
    <div class="video_instructions__form">
      <div class="form-group">
        <label for="name">{{ $t('admin.views.video_instructions.name') }}:</label>
        <div class="flex items-center">
          <input
            id="name"
            type="text"
            v-model="form.name"
          />
        </div>
        <ValidationErrors :errors="errorsFor('name')" />
      </div>
      <div class="form-group">
        <label for="code">{{ $t('admin.views.video_instructions.code') }}:</label>
        <div class="flex items-center">
          <textarea
            id="code"
            v-model="form.code"
          ></textarea>
        </div>
        <ValidationErrors :errors="errorsFor('code')" />
      </div>
    </div>
    <div class="video_instructions__actions">
      <div>
        <button
          @click="remove"
          class="border-sky-blue px-2 rounded"
        >
          <i class="fas fa-times text-red-500"></i>
        </button>
      </div>
      <div>
        <button
          @click="save"
          class="border-sky-blue px-2 rounded"
        >
          <i class="fas fa-save text-green-500"></i>
        </button>
      </div>

    </div>
  </div>
</template>
<script>
import validationErrors from "../../../mixins/validationErrors";
export default {
  name: "VideoInstructionItem",
  mixins: [validationErrors],
  data() {
    return {
      form: {
        name: "",
        code: "",
        id: null,
        tempId: null,
      },
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    posNumber: {
      type: Number,
      default: 1,
    },
  },
  mounted() {
    this.form.name = this.item.name;
    this.form.code = this.item.code;
    this.form.id = this.item.id || null;
    this.form.tempId = this.item.tempId || null;
  },
  methods: {
    async save() {
      try {
        await this.$store.dispatch("videoInstructions/save", this.form);
      } catch (error) {
        this.errors = error.response && error.response.data.errors;
        this.status = error.response && error.response.status;
        console.log(error);
        if (error.response) {
          const notification = {
            type: "error",
            message:
              error.response &&
              error.response.data &&
              error.response.data.message,
          };
          this.$store.dispatch("notification/add", notification, {
            root: true,
          });
        }
      }
    },
    remove() {
      if (
        window.confirm(this.$t("admin.views.video_instructions.confirm_delete"))
      ) {
        this.$store.dispatch("videoInstructions/remove", this.item);
      }
    },
  },
};
</script>
<style scoped>
.video_instructions__item {
  display: flex;
  column-gap: 15px;
}
.video_instructions__form {
  width: 520px;
}
.form-group + .form-group {
  margin-top: 10px;
}
.video_instructions__actions {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding-top: 29px;
}
.video_instructions__actions button {
  display: grid;
  place-content: center;
  height: 30px;
  width: 30px;
}
</style>
